<template>
    <app-overlay-loader v-if="preloader"/>
    <form v-else ref="form" data-url="/contract-settings" class="mb-0" :class="{'loading-opacity': preloader}">
        <div class="form-group row align-items-center">
            <label for="note_po" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('note_po') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input id="note_po"
                           type="textarea"
                           :textAreaRows=10
                           v-model="contract.note_po.value"
                           :required="true" />
            </div>
        </div>

        <div class="form-group row align-items-center">
            <label for="note_so" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('note_so') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input id="note_so"
                           type="textarea"
                           :textAreaRows=10
                           v-model="contract.note_so.value"
                           :required="true" />
            </div>
        </div>
        <div class="form-group row align-items-center">
            <label for="special_conditions" class="col-lg-3 col-xl-3 mb-lg-0">
                {{ $t('special_conditions') }}
            </label>
            <div class="col-lg-8 col-xl-8">
                <app-input id="special_conditions"
                           type="text-editor"
                           :textAreaRows=10
                           :minimal="true"
                           v-model="contract.special_conditions.value"
                           :required="true" />
            </div>
        </div>
        <div class="mt-5 action-buttons">
            <button class="btn btn-primary mr-2" @click.prevent="submit">
                {{ $t('save') }}
            </button>
        </div>
    </form>
</template>

<script>
    import {FormMixin} from "../../../../core/mixins/form/FormMixin";
    import * as actions from "../../../Config/ApiUrl";

    export default {
        name: "index.vue",
        mixins: [FormMixin],
        data() {
            return {
                preloader: false,
                contract: {
                    note_po : {id : null, value : null},
                    note_so : {id : null, value : null},
                    special_conditions : {id : null, value : null},
                },
                showError: false,
            }
        },
        created() {
            this.getData();
        },
        methods: {

            beforeSubmit() {
                this.preloader = true;
            },
            submit() {
                this.save(this.contract);
            },
            afterFinalResponse() {
                this.preloader = false;
            },
            afterSuccess(res) {
                console.log(res);
                
                this.$toastr.s(res.data.message);
            },
            afterError(res) {
                this.showError = true;
                this.$toastr.e(res.data.message);
            },
            getData() {
                this.preloader = true;
                let url = actions.GET_CONTRACT_SETTINGS;
                this.axiosGet(url).then(response => {
                    if (response.data) {
                        const data = response.data;
                        data.forEach(element => {
                            if (element.name === 'note_po') {
                                this.contract.note_po.value = element.value;
                                this.contract.note_po.id = element.id;
                            }
                            if (element.name === 'note_so') {
                                this.contract.note_so.value = element.value;
                                this.contract.note_so.id = element.id;
                            }
                            if (element.name === 'special_conditions') {
                                this.contract.special_conditions.value = element.value;
                                this.contract.special_conditions.id = element.id;
                            }
                        });
                    }
                }).catch(({response}) => {

                }).finally(() => {
                    this.preloader = false;
                });
            }
        }
    }
</script>
